import { Modal } from '@components/UI/Html';
import env from '@config/env';
import logger from '@libs/log';
import { fetchSimulationEmails } from '@state/redux/slices/project.slice';
import { useAppDispatch, useAppSelector } from '@state/redux/store';
import Api from '@state/utils/Api';
import { useEffect, type Dispatch, type SetStateAction } from 'react';
import useSWR from 'swr';
import EmailMessenger from '.';

interface EmailModalProps {
  modal: boolean;
  setModal: Dispatch<SetStateAction<boolean>>;
}
function EmailModal({ modal, setModal }: EmailModalProps) {
  const toggle = () => {
    setModal(!modal);
  };

  const projectId = useAppSelector((state) => state.projects.currentProject.project.id);

  const fetcher = async () => {
    const response = await Api.getSimulationEmails(projectId);
    return response.data.data;
  };

  const swrKey = projectId ? `/projects/${projectId}/simulation_emails` : null;

  const { data: emails = [] } = useSWR(swrKey, fetcher, {
    refreshInterval: env.PROD ? 5000 : undefined,
  });

  const userProjectEmails = emails;
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchSimulationEmails({ projectId })).catch(() => {
      logger.error('Failed to fetch simulation emails');
    });
  }, []);

  return (
    <>
      {/* <NotificationModal
        isOpen={showInitialNotification && initialUnreadCount > 0}
        toggle={() => {
          setShowInitialNotification(false);
        }}
        icon={inboxIcon}
        title={translate('notificationModal.newMessage')}
        message={
          initialUnreadCount === 1 && senderName
            ? translate('notificationModal.newMessageMessageFrom', { senderName })
            : translate('notificationModal.newMessagesCount', { count: initialUnreadCount })
        }
        onViewMessage={() => {
          setShowInitialNotification(false);
          toggle();
        }}
        buttonIcon="https://cartedo.s3.us-east-2.amazonaws.com/web/499a44c4e3f38aad9848.png"
        buttonText={translate('notificationModal.clickToViewEmail')}
      /> */}
      <Modal
        size="lg"
        isOpen={modal}
        toggle={toggle}
        showCloseButton={false}
        style={{ content: { padding: '0px 24px 24px' } }}
        // external={externalCloseBtn}
      >
        <EmailMessenger onClose={toggle} emails={userProjectEmails} />
      </Modal>
    </>
  );
}

export default EmailModal;
